module.exports = __webpack_public_path__ + "img/schokotortevegan.e1ffa00c.jpg";